import { render, staticRenderFns } from "./HeatWave.vue?vue&type=template&id=5ff83115&scoped=true&"
import script from "./HeatWave.vue?vue&type=script&lang=js&"
export * from "./HeatWave.vue?vue&type=script&lang=js&"
import style0 from "./HeatWave.vue?vue&type=style&index=0&id=5ff83115&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff83115",
  null
  
)

export default component.exports